export default "__VITE_ASSET__DiIVc9ZJ__"